import axios from "./api";

export const getPharmacoVigilance = () => {
  return axios.get(`/site/content/pharmacovigilance?v=${Math.random()}`).then((res) => res.data);
};
